import { all } from "redux-saga/effects";
import FaqSagas from "./FaqSagas";
import PrivilegeSagas from "./PrivilegeSagas";
import CategorySagas from "./CategorySagas";
import WishListSagas from "./WishListSagas";
import AuthSagas from "./AuthSagas";
import WalletSagas from "./WalletSagas";
import RedeemSagas from "./RedeemSagas";
import ShopcodeSagas from "./ShopcodeSagas";
import CouponSagas from "./CouponSagas";

import ForgotPassword from "./ForgotPasswordSagas";
export default function* rootSaga() {
  yield all([
    FaqSagas(),
    PrivilegeSagas(),
    CategorySagas(),
    WishListSagas(),
    AuthSagas(),
    RedeemSagas(),
    WalletSagas(),
    ShopcodeSagas(),
    CouponSagas(),
    ForgotPassword()
  ]);
}
